import React from 'react';
import { tierColor, type Tier } from '../theme/tokens';

interface VerdictBoxProps {
  tier: Tier;
  headline: string;
  sub: string;
}

/**
 * The verdict block on the detail screen: tier-tinted background, big headline + sub.
 */
export const VerdictBox: React.FC<VerdictBoxProps> = ({ tier, headline, sub }) => {
  const { fg, bg } = tierColor(tier);
  return (
    <div
      className="rounded-lg p-s4 border"
      style={{ backgroundColor: bg, borderColor: `${fg}33` }}
    >
      <div className="flex items-center gap-2 mb-1.5">
        <span
          className="block rounded-full"
          style={{ width: 8, height: 8, backgroundColor: fg }}
        />
        <span
          className="caption"
          style={{ color: fg }}
        >
          Verdict
        </span>
      </div>
      <div
        className="font-serif text-[22px] leading-tight mb-1 tracking-tight"
        style={{ color: fg }}
      >
        {headline}
      </div>
      <div className="text-[13px] leading-snug font-sans text-ink2">{sub}</div>
    </div>
  );
};
